import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../context/auth';
import moment from 'moment';
import { Col, Row, Button, Card } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//API
import regional_api from '../../../../api/regional_api';
import relatorio_api from '../../../../api/relatorio_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { objCampo, validarCampos, isDateOverflow } from '../../../../helpers/ValidadorDeCampos';

//Components
import TextField from '../../../../components/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import MapaTermico from '../components/MapaTermico';


function initialStateFiltroMapaTermico() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);

    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
        regional_Id: 0
    }
}
export default function MapaTermicoFiscalizacoesRelatorio() {
    const { setLoading } = useAuth();
    const navigate = useNavigate();

    //State para consultar Fiscalizações
    const [filtroFiscalizacao, setFiltroFiscalizacao] = useState(initialStateFiltroMapaTermico());

    //State para pegar lista das regionais
    const [listRegional, setListRegional] = useState([]);

    //State para pegar todas as fiscalizações conforme filtro
    const [listFiscalizacoes, setListFiscalizacoes] = useState();
    
    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
    ]);

    const loadRegional = () => {
        setLoading(true);
        regional_api.getList()
            .then(response => {
                response.data.map(value => {
                    value.value = value.id;
                    value.label = value.identificacao;
                    return value;
                })
                setListRegional(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setFiltroFiscalizacao({
            ...filtroFiscalizacao,
            [name]: value
        })
    }

    const onChangeRegional = (value, e) => {
        setFiltroFiscalizacao({
            ...filtroFiscalizacao,
            [e.name]: value ? value.value.toString() : null,
        })
    }
    
    const handleFiltroMapaTermicoFiscalizacoes = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(filtroFiscalizacao, campos);
        
        setErrors(_errors[0]);
        if (_errors[1].length > 0) return true;
        
        // Verifica se o período é maior que 12 meses
        if(isDateOverflow(filtroFiscalizacao.dataInicial, filtroFiscalizacao.dataFinal, 12, 'months')) {
            setErrors({dataInicial: {message: ''}, dataFinal: {message: ''}})
            showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null)
            return
        };

        setLoading(true);
        relatorio_api.MapaFiscalizacoes(filtroFiscalizacao)
            .then(response => {
                setListFiscalizacoes(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
            
    }

    const handleVoltar = () => {
        setListFiscalizacoes(null);
    }

    useEffect(() => {
        loadRegional();
    }, []);


    if (listFiscalizacoes) {
        return <MapaTermico dados={listFiscalizacoes} handleVoltar={handleVoltar} />
    }

    return <Card className='shadowFicha mainContainerFicha p-4'>
        <div className='mb-3'>
            <Button color='secondary' className='text-white' onClick={() => navigate(-1)}>
                <FontAwesomeIcon icon={faArrowLeft} />
                <span className='px-2'> Voltar </span>
            </Button>
        </div>
        <h4 className='text-secondary m-0'>Mapa Térmico de Fiscalizações</h4>
        <Row className='mt-3'>
            <Col md={12} lg={4}>
                <TextField
                    type={"select"}
                    name={"regional_Id"}
                    label={"* Regional"}
                    placeholder='TODAS'
                    searchable
                    options={listRegional}
                    onChange={onChangeRegional}
                    value={listRegional.filter(value => value.value == filtroFiscalizacao.regional_Id)}
                    invalid={!!errors.regional_Id}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"date"}
                    name={"dataInicial"}
                    label={"* Data Inicial"}
                    onChange={onChange}
                    value={filtroFiscalizacao.dataInicial}
                    invalid={!!errors.dataInicial}
                    />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"date"}
                    name={"dataFinal"}
                    label={"* Data Final"}
                    onChange={onChange}
                    value={filtroFiscalizacao.dataFinal}
                    invalid={!!errors.dataFinal}
                />
            </Col>
            <Col md={12} lg={2}>
                <Button
                    className='w-100 fw-bold mt-2'
                    color='info text-light'
                    onClick={handleFiltroMapaTermicoFiscalizacoes}>Gerar Mapa</Button>
            </Col>
        </Row>
    </Card>;
}
